import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { Tabs, Tab } from '../shared/tabs.component';
import StatusBadge from '../shared/statusBadge.component';
import TaxExpenseReportTab from './taxExpenseReportTab.component';
import TrialBalanceTab from './trialBalanceTab/trialBalanceTab.component';
import JournalTab from './journalTab/journalTab.component';
import CalculationSettingsTab from './calculationSettingsTab/calculationSettingsTab.component';
import AdjustmentsTab from './adjustmentsTab/adjustmentsTab.component';
import EffectiveTaxRateTab from './effectiveTaxRateTab/effectiveTaxRateTab.component';

export const TabTypes = {
  TAX_EXPENSE_REPORT: 'TAX_EXPENSE_REPORT',
  JOURNALS: 'JOURNALS',
  TRIAL_BALANCE: 'TRIAL_BALANCE',
  CALCULATION_SETTINGS: 'CALCULATION_SETTINGS',
  ADJUSTMENTS: 'ADJUSTMENTS',
  ETR: 'ETR',
};

class ProvisionDetails extends PureComponent {
  static propTypes = {
    activeTab: PropTypes.oneOf(Object.values(TabTypes)).isRequired,
    changeTab: PropTypes.func.isRequired,
    chartName: PropTypes.string.isRequired,
    statusName: PropTypes.string,
  };

  changeTab = (event, tabType) => {
    this.props.changeTab(tabType);
    setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
  };

  render() {
    const {
      activeTab,
      chartName,
      statusName,
    } = this.props;

    return (
      <div className="provision-details page-content-container">
        <StatusBadge value={statusName}/>
        <Tabs
          defaultValue={TabTypes.TAX_EXPENSE_REPORT}
          value={activeTab}
          onChange={this.changeTab}
          className="a-tab-bar-margin-10"
          size="md"
        >
          <Tab value={TabTypes.TAX_EXPENSE_REPORT} label="Tax Expense Report">
            <TaxExpenseReportTab />
          </Tab>

          <Tab value={TabTypes.JOURNALS} label="Journals">
            <JournalTab chartName={chartName} />
          </Tab>

          <Tab value={TabTypes.TRIAL_BALANCE} label="Trial Balance">
            <TrialBalanceTab
              chartName={chartName}
            />
          </Tab>

          <Tab value={TabTypes.CALCULATION_SETTINGS} label="Calculation Settings">
            <CalculationSettingsTab />
          </Tab>

          <Tab value={TabTypes.ADJUSTMENTS} label="Adjustments">
            <AdjustmentsTab />
          </Tab>

          <Tab value={TabTypes.ETR} label="ETR">
            <EffectiveTaxRateTab />
          </Tab>
        </Tabs>
      </div>
    );
  }
}

export default ProvisionDetails;
